import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { FileText } from 'lucide-react';
export function Section3() {
  return <section className="py-20 bg-dark text-white px-6" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <FadeIn data-id="element-141">
          <h2 className="text-3xl md:text-5xl font-bold text-gold mb-8 text-center" data-id="element-142">
            LO QUE ESTE MANUAL HACE POR TI
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-143">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-6 text-lg text-gray-300" data-id="element-144">
            <p data-id="element-145">
              No te voy a vender un curso de 10 horas. No te voy a cobrar $150
              al mes por enviarte cartas. Te voy a dar el manual que yo mismo
              usé para dejar de rentar y comprar mi primera casa.
            </p>
            <p data-id="element-146">
              En un solo PDF tienes el plan de acción, las leyes explicadas en
              español real y las cartas que solo tienes que rellenar con tu
              nombre, imprimir y enviar.
            </p>
            <p className="text-gold font-medium" data-id="element-147">
              Esto es exactamente lo que está dentro:
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-148">
          <FadeIn delay={0.3} data-id="element-149">
            <div className="bg-neutral-800 p-8 rounded-sm border border-gold/20 h-full" data-id="element-150">
              <h3 className="text-xl font-bold text-gold mb-4 flex items-center gap-2" data-id="element-151">
                <span data-id="element-152">📌</span> PARTE 1: LA AUDITORÍA
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-153">
                Cómo obtener tus 3 reportes gratuitos sin bajar tu score. Qué
                buscar exactamente: errores de nombre, fechas manipuladas,
                deudas duplicadas y cuentas que no son tuyas. Cómo "congelar" a
                las agencias secundarias (LexisNexis, SageStream) para que los
                Bureaus no puedan verificar información con terceros cuando
                envíes tus disputas.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-154">
            <div className="bg-neutral-800 p-8 rounded-sm border border-gold/20 h-full" data-id="element-155">
              <h3 className="text-xl font-bold text-gold mb-4 flex items-center gap-2" data-id="element-156">
                <span data-id="element-157">📌</span> PARTE 2: LAS ARMAS LEGALES
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-158">
                La Ley FCRA Sección 609 explicada en español sin términos
                complicados. Por qué los Bureaus están legalmente obligados a
                borrar lo que no pueden probar. La Ley FDCPA y cómo usarla para
                silenciar a los cobradores de deudas. El vacío legal de la Ley
                HIPAA para eliminar deudas médicas de tu reporte.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-159">
          <div className="bg-gold/10 border border-gold p-8 md:p-12 rounded-sm mb-16" data-id="element-160">
            <h3 className="text-2xl md:text-3xl font-bold text-gold mb-6 flex items-center gap-2" data-id="element-161">
              <span data-id="element-162">📌</span> PARTE 3: LA BÓVEDA DE CARTAS
            </h3>
            <p className="text-gray-200 mb-8 text-lg" data-id="element-163">
              Aquí están las plantillas. No en un bono aparte. No en un archivo
              separado. Dentro del mismo manual, encontrarás el texto exacto en
              el inglés legal que los Bureaus respetan. Solo rellenas tu nombre
              y tu información, imprimes y envías por correo certificado.
            </p>

            <p className="text-gold font-medium mb-6" data-id="element-164">
              Las cartas incluidas son:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-165">
              {['Carta de Corrección de Identidad', 'Carta de Disputa de Verificación (Ley 609)', 'Carta de Violación por Falta de Respuesta', 'Carta para Deudas Médicas (Protocolo HIPAA)', 'Carta de Negociación "Pay for Delete"'].map((carta, i) => <div key={i} className="flex items-center gap-3 bg-dark p-4 rounded border border-gold/30" data-id="element-166">
                  <FileText className="text-gold shrink-0" size={20} data-id="element-167" />
                  <span className="text-white font-medium" data-id="element-168">{carta}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-169">
          <FadeIn delay={0.6} data-id="element-170">
            <div className="bg-neutral-800 p-8 rounded-sm border border-gold/20 h-full" data-id="element-171">
              <h3 className="text-xl font-bold text-gold mb-4 flex items-center gap-2" data-id="element-172">
                <span data-id="element-173">📌</span> PARTE 4: LA RECONSTRUCCIÓN
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-174">
                Cómo subir 50 puntos en un solo ciclo de facturación usando la
                Regla del 7%. Cómo convertirte en Usuario Autorizado de una
                cuenta con buen historial sin que esa persona corra ningún
                riesgo. Las 5 tarjetas más fáciles de aprobar para hispanos que
                reportan a los 3 Bureaus simultáneamente.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.7} data-id="element-175">
            <div className="bg-neutral-800 p-8 rounded-sm border border-gold/20 h-full" data-id="element-176">
              <h3 className="text-xl font-bold text-gold mb-4 flex items-center gap-2" data-id="element-177">
                <span data-id="element-178">📌</span> PARTE 5: LA RUTA HIPOTECARIA
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-179">
                Qué score mínimo necesitas realmente para un préstamo FHA vs.
                convencional. Cómo preparar tus estados de cuenta bancarios 90
                días antes de aplicar. Qué decir y qué nunca decir al oficial de
                préstamo para que la conversación termine en aprobación.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.8} data-id="element-180">
          <div className="text-center" data-id="element-181">
            <Button data-id="element-182">[ DESCARGAR MI PASAPORTE FINANCIERO — $16 AHORA ]</Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}